import { Box, IconButton, Tooltip } from "@mui/material";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import EditOffIcon from "@mui/icons-material/EditOff";
import AutoFixHighOutlinedIcon from "@mui/icons-material/AutoFixHighOutlined";

import { LayoutContext } from "../../../contexts/layout/context";
import { VersionedDataContext } from "../../../contexts/versioned_data/context";
import { ChatContext } from "../../../contexts/chat/context";

export const AIButton = () => {
  const { isSidebarOpen, setIsSidebarOpen } = useContext(LayoutContext);
  const { mainRun, lastSuccessfulRun } = useContext(VersionedDataContext);
  const { disconnectChat, connectChat, transportKind } =
    useContext(ChatContext);

  const { pathname } = useLocation();
  const disabled = transportKind !== "platform" && pathname !== "/demand";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mt: 1,
      }}
    >
      <Tooltip
        title={
          isSidebarOpen
            ? "Close Nucleus"
            : transportKind === "platform"
              ? "Ask Nucleus about this run"
              : "Edit Run with Nucleus"
        }
      >
        <IconButton
          aria-label={
            isSidebarOpen
              ? "Close Nucleus"
              : transportKind === "platform"
                ? "Ask Nucleus about this run"
                : "Edit Run with Nucleus"
          }
          disabled={disabled}
          onClick={() => {
            if (disabled) return;
            if (isSidebarOpen) {
              setIsSidebarOpen(false);
              if (transportKind !== "platform") disconnectChat();
            } else {
              if (transportKind === "platform") {
                setIsSidebarOpen(true);
                return;
              }

              const run = mainRun || lastSuccessfulRun;
              const connection = Promise.resolve(connectChat(run, "forecast"));
              const openSidebar = () => setIsSidebarOpen(true);
              void connection.then(openSidebar, openSidebar);
            }
          }}
          sx={{
            backgroundColor: isSidebarOpen
              ? "primary.main"
              : "rgba(210, 208, 208, 0.54)",
            position: "relative",
            color: isSidebarOpen ? "white" : "action.active",
            "&:hover": {
              backgroundColor: isSidebarOpen ? "primary.dark" : "primary.main",
              color: "white",
              ...(isSidebarOpen && {
                "& .edit-off-hover": {
                  opacity: 1,
                  visibility: "visible",
                },
              }),
            },
          }}
        >
          {transportKind === "platform" ? (
            <AutoFixHighOutlinedIcon sx={{ height: "20px", width: "20px" }} />
          ) : (
            <EditIcon sx={{ height: "20px", width: "20px" }} />
          )}
          {transportKind !== "platform" && (
            <EditOffIcon
              className="edit-off-hover"
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                height: "20px",
                width: "20px",
                opacity: 0,
                visibility: "hidden",
                transition: "opacity 0.2s ease, visibility 0.2s ease",
                pointerEvents: "none",
              }}
            />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
};
